import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";


const ValuerAmendColumnContainer = (props) => {

    const summaryId = props.summaryId
    const sectionName = props.sectionName
    const fieldList = props.fieldList

    // Values
    const values = props.values

    // Functions
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    return (
        <div className="valuer-amend-column-container" style={{margin: props.disableMargin ? 'unset' : null}}>
            <ValuerAmendFieldListHandler fieldList={fieldList}
                                         sectionName={sectionName}
                                         summaryId={summaryId}
                                         setErrorMessage={setErrorMessage}
                                         setErrorTitle={setErrorTitle}
                                         values={values}
                                         UpdateParentValue={UpdateParentValue}
                                         AddToQueue={AddToQueue}
                                         RemoveFromQueue={RemoveFromQueue}
                                         AddToErroredSaves={AddToErroredSaves}/>
        </div>
    )
}

export default ValuerAmendColumnContainer;